import { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { SpinnerButton } from 'src/components/base/Elements';
import { withModalDialog } from 'src/components/base/ModalDialog';
import { ImageFileInput } from 'src/components/base/ImageFileInput';
import { useAction } from 'src/hooks/action';

import classes from './LocationDialog.module.scss';

const MAX_SIZE = 5 * 1024 * 1024;

export const ImageUploadDialog = withModalDialog(({ onClose, createImage }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const [submitAction, isSaving] = useAction(async (event) => {
    event.preventDefault();
    await createImage(selectedImage);
    onClose(selectedImage);
  });

  return (
    <section className={classes.root}>
      <Form role="form">
        <Modal.Header closeButton>
          <Modal.Title>{__('Upload Image')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{__('Supported formats: JPG, PNG, GIF. Maximum file size: 5MB.')}</p>

          <Form.Group className="mb-3">
            <ImageFileInput accept={'image/*'} maxSize={MAX_SIZE} onImageSelect={setSelectedImage} />
          </Form.Group>

        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => onClose()}>{__('Cancel')}</Button>
          <SpinnerButton variant="primary" type="submit" onClick={submitAction} disabled={!selectedImage} animated={isSaving}>{__('Add Image')}</SpinnerButton>
        </Modal.Footer>

      </Form>
    </section>  
  )
}, { size: 'md' })